









































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import { Button, Table, TableColumn } from 'element-ui';
import NProgress from 'nprogress';
import MyNav from '@/components/skeleton/top.vue'; // nav
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import Devisive from '@/servers/modules/decisive/index';
// server
@Component({
  components: {
    Table,
    TableColumn,
    Button,
    MyDialog,
    MyNav,
  },
})
export default class extends Vue {
    // 本地缓存基础数据-课程名称
    @Getter public basicData: any;

    @Getter public navData: any;

    @Getter public skeleton: any;

    @Mutation public setSkeletonDescribe;

    @Mutation public openDialog;

    @Mutation public closeDialog:any;

    // 左侧菜单栏
    @Getter public scaleCommonIndex: any;

    private tableData:any = [];

    private title:string = '';

    private tableHeaderClassName() {
      return 'table-header';
    }

    private cellClassName({
      row, column, rowIndex, columnIndex,
    }:any) {
      if (columnIndex === 0) {
        return 'cell-style';
      }
      return '';
    }

    private tableRowClassName() {
      return 'table-row';
    }

    // 合并行或者列
    private objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (row.rowSpan) {
        if (columnIndex === 0) {
          if (!row.rowIndex) {
            return {
              rowspan: row.rowSpan,
              colspan: 1,
            };
          }
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    }

    private created() {
      this.title = window.LS.get('basicData').courseName;
      NProgress.start();
      this.studyTaskList();
    }

    // 学习任务列表
    private async studyTaskList() {
      const para = {
        nodeGroupId: window.LS.get('jse_data').nodeGroupId,
        processInstanceId: window.LS.get('jse_data').processInstanceId,
      };
      const res = await Devisive.studyTaskList(para);
      const tableData = [];
      function copyObject(data, tag? = {}) {
        for (const i in data) {
          tag[i] = data[i];
        }
        return tag;
      }
      // 对数据进行管理整合
      const { data } = res.data;
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length > 1) {
          const data2:any = data[i].children;
          for (let j = 0; j < data2.length; j++) {
            const data1:any = copyObject(data[i]);
            // 为第一个单元格增加特殊的标识内容
            data1.rowSpan = data2.length;
            data1.rowIndex = j && 1;
            data1.children = [data2[j]];
            tableData.push(data1);
          }
        } else {
          tableData.push(data[i]);
        }
      }
      this.tableData = tableData;
      NProgress.done();
    }
}
